// This file is generated by next-core EcmascriptClientReferenceModule.
import { registerClientReference } from "react-server-dom-turbopack/server";
export const AuthorDetailView = registerClientReference(
    function() { throw new Error("Attempted to call AuthorDetailView() from the server but AuthorDetailView is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/components/authors/author-detail-view.tsx",
    "AuthorDetailView",
);
